import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, Subject } from "rxjs";
import { ApiService } from "src/app/features/http-services/api.service";
// import { API_CONSTANTS } from "src/app/features/shared/constants/API-CONSTANTS";
// import { UserService } from "src/app/features/shared/user/services/user.service";
import { delay, map, switchMap, take } from "rxjs/operators";
import { StorageService } from "src/app/features/http-services/storage.service";
import { Router } from "@angular/router";
import { UserService } from "src/app/features/dashboard/user/services/user.service";
import { API_CONSTANTS } from "../../../constants/api";
import { SharedService } from "src/app/features/http-services/shared.service";

@Injectable({
  providedIn: "root",
})
export class AsmService {
  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private storageService: StorageService,
    private router: Router,
    private sharedService: SharedService,
  ) {}
  getCustomerList(): Observable<any> {
    let url = API_CONSTANTS.getCustomerList;
    return this.apiService.getAsm(url, {}).pipe(map((error) => error));
  }
  getAutoComplete(customerQueries: any): Observable<any> {
    let url = API_CONSTANTS.listAutocomplete;
    return this.apiService
      .getAsm(`${url}?customerQuery=${encodeURIComponent(customerQueries)}`, {})
      .pipe(map((error) => error));
  }
  updateProfile(email: any): Observable<any> {
    // let url = API_CONSTANTS.setProfile.replace(
    //   "{userId}", email
    // )
    // const impersonateFlag: boolean = true
    // return this.apiService.get(`${url}?impersonateFlag=${impersonateFlag}`, {}).pipe(map(error => error));
    this.userService.asmUserInfo = {
      isAsmUser: true,
      asmUser: email,
    };
    if (email === "") {
      this.userService.asmUserInfo = {};
      const prevUser: any = localStorage.getItem("userNamesTemp");
      localStorage.setItem("userNames", prevUser);
     // this.userService.setUserEmail(String(localStorage.getItem("loginUser")));

     this.userService.setUserEmail(prevUser);

      localStorage.setItem("userNamesTemp", this.userService.getUserEmail());
    } else {
      localStorage.setItem("userNames", email);
      
      localStorage.setItem("userNamesTemp", this.userService.getUserEmail());
      this.userService.setUserEmail(email);
      this.userService.asmUserInfo = {
        isAsmUser: true,
        asmUser: this.userService.getUserEmail(),
      };
    }
    // this.userService.userEmail = undefined;
    // this.userService.currentUserDetails.next(null);
    return this.storageService.getItem("customer-details").pipe(take(1));

    // return this.userService.getCurrentUserDetail();
  }

  getUserEmail() {
    const storedEmail = localStorage.getItem("userEmail");
    return storedEmail || '';
  }

  // setUnit(urlExt: string) {
  //   let url;
  //   if (urlExt === "?unitUid=undefined") {
  //     urlExt = "?unitUid=";
  //     url =
  //       API_CONSTANTS.setUnit.replace("{userId}", this.getUserEmail()) + urlExt;
  //   } else {
  //     url =
  //       API_CONSTANTS.setUnit.replace("{userId}", this.getUserEmail()) + urlExt;
  //   }
  //   return this.apiService.patch(url, {}).pipe(
  //     map((res: any) => {
  //     })
  //   );
  // }

  getMiniCart(data: any = {}) {
    this.apiService.getMiniCartData(data).subscribe({
      next: (result: any) => {
        
        this.storageService.setItem("miniCartCount", result);
      },
      error: (error: any) => {
        this.storageService.setItem("miniCartCount", "");
      },
    });
  }

  navigateUsers(data: any) {
    let storefront =
      data?.defaultStorefront === "R" ? "residential" : "commercial";
    this.userService.setEnvironment(storefront);

    // let store= this.router.url.includes('residential')?'residential':'commercial';
    
    if (data?.isCustomer) {
      this.router.navigate(["/"]);
      if (data.accounts?.length > 1) {
        const multiAccounts = data.accounts.filter(
          (item: any) => item.company === data.defaultStorefront
        );
        if (multiAccounts.length == 1) {
          this.router.navigate(["/"]);
        } else {
          this.router.navigate(["/multiple-accounts"]);
        }
      }
    }
    if (data?.isCSR) {
      this.router.navigate(["/csr"]);
    }
    if (data?.isSalesPerson || data?.isSalesOps) {
       if (this.router.url.includes('/salesman-dashboard')) {
               this.sharedService.triggerSalesmanDashboardRefresh();
       } else {
          this.router.navigate(["/salesman-dashboard"]);
       }
    }
  }

  setDefaultUnit(data:any = {}, payload: any = {}) {
    const endpoint = API_CONSTANTS.setUnit
      .replace("{userId}", data.userId)
      .replace("{unitUid}", data.unitUid)
    return this.apiService.patch(endpoint, payload).pipe(map(({ body }: any) => body));
  }
}
